import type { RouteRecordRaw } from 'vue-router'
import { useAccountStore } from '@/store/account'
import {
  CUSTOMER_CREATE_PASSWORD,
  CUSTOMER_FORGOT_PASSWORD,
  CUSTOMER_RESET_PASSWORD,
  LOGIN_PAGE,
  REGISTRATION,
} from '@/types/router'

const authRoutes: Array<RouteRecordRaw> = [
  {
    path: '/forgot-password',
    component: () => import('@/views/Account/ForgotPass.vue'),
    name: CUSTOMER_FORGOT_PASSWORD,
    meta: {
      title: 'Forgot Password',
      guest: true,
    },
  },
  {
    path: '/create-password/',
    component: () => import('@/views/Account/CreatePass.vue'),
    name: CUSTOMER_CREATE_PASSWORD,
    meta: {
      title: 'Create Password',
      guest: true,
    },
  },
  {
    path: '/reset-password/',
    component: () => import('@/views/Account/ResetPass.vue'),
    name: CUSTOMER_RESET_PASSWORD,
    meta: {
      title: 'Reset Password',
      guest: true,
    },
  },
  {
    path: '/',
    name: LOGIN_PAGE,
    component: () => import('@/views/Account/Login.vue'),
    meta: {
      guest: true,
    },
    beforeEnter: (to, _from) => {
      const accountStore = useAccountStore()

      if (!accountStore.isLoggedIn) {
        return true
      } else {
        if (to.name !== accountStore.homePage) {
          return { name: accountStore.homePage }
        } else {
          return true
        }
      }
    },
  },
  {
    path: '/registration',
    name: REGISTRATION,
    component: () => import('@/views/Account/Registration.vue'),
    meta: {
      guest: true,
    },
  },
]

export default authRoutes
